import { IHistoricoUploadItemView } from './models/historico-upload.model';

export class HistoricoUploadController {

    public opened = false;
    public items: IHistoricoUploadItemView[] = [];
    public loading = false;
    public loadError = false;
    public subtitle = '';
    public badgeLabel = '';
    public badgeClass = '';
    public onClose?: () => void;

    fechar() {
        if (this.onClose) {
            this.onClose();
        }
    }

    hasItems() {
        return !!this.items.length;
    }
}
